import '../../css/ajaxLoader.naja.css';

export default class AjaxLoaderExtension {
	constructor (naja, loaderId) {
		naja.addEventListener('init', function () {
			this.loaderId = loaderId ?? 'ajax-loader';
			this.getElementSpinner(); // first initialize spinner
			this.enabled = true;
			this.name = 'ajax-loader';
		}.bind(this));

		naja.addEventListener('start', this.showLoader.bind(this));
		naja.addEventListener('complete', this.hideLoader.bind(this));
		naja.addEventListener('interaction', this.checkSpinner.bind(this));
		naja.addEventListener('before', this.checkSpinner.bind(this));
		naja.addEventListener('error', (e) => {
			console.error(e);
			this.hideLoader();
		});
	}

	getElementSpinner() {
		if (this.loader === null || this.loader === undefined) {
			let elem = document.querySelector('#' + this.loaderId);
			if(!elem) {
				const div = document.createElement('div');
				div.id = this.loaderId;
				div.classList.add('ajax-loader');
				div.style.display = 'none';

				if (__webpack_nonce__) {
					div.setAttribute('nonce', __webpack_nonce__);
				}

				document.body.appendChild(div);
				elem = document.querySelector('#' + this.loaderId);
			}
			this.loader = elem;
		}

		return this.loader;
	}

	checkSpinner(_ref) {
		const element = _ref.element,
			options = _ref.options;

		this.enabled = element
			? element.getAttribute('data-naja-spinner') !== 'off'
			: options.spinner !== false;

		// propagate to options if called in interaction event
		options.spinner = this.enabled;
	}

	showLoader() {
		if (this.enabled) {
			this.getElementSpinner().style.display = 'block';
		}
	}

	hideLoader(response) {
		if (this.enabled) {
			this.getElementSpinner().style.display = 'none';
		}
		this.enabled = true;
	}
}